import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import SectionHeader from "./SectionHeader";
import ReviewCard from "./ReviewCard";
import { http } from "../axios/axios";
import ReviewFormModal from "./modal/ReviewFormModal";

export const ProductReviews = ({ productId }) => {
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [reviews, setReviews] = useState([]);

  const fetchReviews = async () => {
    try {
      const res = await http.get(`reviews/${productId}/productReview`);

      setReviews(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);
  const onClose = () => {
    setReviewModalOpen(false);
  };
  return (
    <section className="">
      <SectionHeader
        badge="Product Reviews"
        title="What Customers Say About Our Products"
        description="Discover genuine feedback from customers who use our security products. Read their experiences, ratings, and insights—or share your own review to help others make informed decisions."
        showLine
        secondAction={
          <button
            onClick={() => setReviewModalOpen(true)}
            className="group inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-blue-600 transition-colors"
          >
            Write a Review
            <ArrowRight
              size={14}
              className="transition-transform group-hover:translate-x-1"
            />
          </button>
        }
        action={
          <Link
            to="/reviews"
            className="group inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-blue-600 transition-colors"
          >
            View All Reviews
            <ArrowRight
              size={14}
              className="transition-transform group-hover:translate-x-1"
            />
          </Link>
        }
      />
      {reviews.length > 0 ? (
        <div className="mt-12 grid items-start gap-8 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((review) => (
            <ReviewCard
              key={review._id}
              review={review}
            />
          ))}
        </div>
      ) : (
        <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-50 p-10 text-center">
          <h3 className="text-xl font-semibold text-slate-900">
            No Reviews Yet
          </h3>
          <p className="mt-2 text-slate-600">
            This product hasn't received any reviews yet. Be the first to share
            your experience!
          </p>

          <button
            onClick={() => setReviewModalOpen(true)}
            className="mt-6 inline-flex items-center rounded-lg bg-blue-600 px-5 py-2.5 text-white transition hover:bg-blue-700"
          >
            Write the First Review
          </button>
        </div>
      )}
      <AnimatePresence>
        {reviewModalOpen && (
          <ReviewFormModal onClose={onClose} onSuccess={fetchReviews} />
        )}
      </AnimatePresence>
    </section>
  );
};
